module.exports = __webpack_public_path__ + "static/media/6.610eacc5.png";